import gql from 'graphql-tag';

import { lessonFragment } from '~/shared/graphql-queries/lessons/index';

export default gql`
  mutation updateByIdLessonMutation(
    $_id: MongoID!
    $record: UpdateByIdLessonInput!
  ) {
    updateByIdLessonMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...LessonFragment
      }
      message
      title
    }
  }
  ${lessonFragment}
`;
